import type { IFieldDefinition } from '@platform/core/types';

/** Короткий текст — коди й номери (UIUX/field-types/short-text; прототип SHORT_TEXT): ключ закінчується на code, no, num, regno, ref, id… */
const SHORT_TEXT = /(^|_)(code|no|num|number|regno|ref|id|phone|zip|postcode|year|qty)$/i;

export function isShortText(field: IFieldDefinition): boolean {
  return field.type === 'text' && SHORT_TEXT.test(field.key);
}
